import React from 'react';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import styles from './preview-blocker.module.scss';
const OFFSET = 20;
// we block user from doing any click on preview, just because it doesn't work well
const PreviewBlocker = ({ isMobile }) => {
    const [coords, setCoords] = React.useState({ x: null, y: null });
    const [position, setPosition] = React.useState({});
    const floaterRef = React.useRef(null);
    const containerRef = React.useRef(null);
    const t = useTranslate();
    React.useLayoutEffect(() => {
        if (coords.y) {
            const cRect = containerRef?.current?.getBoundingClientRect();
            const fRect = floaterRef?.current?.getBoundingClientRect();
            if (cRect && fRect) {
                const isPositionedLeft = cRect.right - coords.x > 150;
                setPosition({
                    top: coords.y - (cRect ? cRect.y : 0) + OFFSET,
                    [isPositionedLeft ? 'left' : 'right']: isPositionedLeft
                        ? isMobile
                            ? Math.min(coords.x, 200)
                            : coords.x - (cRect ? cRect.x : 0) - OFFSET / 2
                        : cRect.right - coords.x - OFFSET / 2,
                });
            }
        }
    }, [coords]);
    return (React.createElement("div", { ref: containerRef, className: styles.container, title: t('preview-blocker.title'), onClick: (ev) => setCoords({
            x: ev.clientX,
            y: ev.clientY,
        }) }, coords.y && (React.createElement("span", { ref: floaterRef, className: styles.floatingText, style: { ...position } }, t('preview-blocker.popup')))));
};
export default PreviewBlocker;
//# sourceMappingURL=preview-blocker.js.map